/** Flyer — document knowledge definition. Pure data. */
export default {
  id: 'flyer',
  name: 'Flyer',
  description: 'A single-page promotional handout for events, offers, and local marketing.',
  purpose: 'Marketing & Promotion',
  recommendedSizes: [
    { name: 'A5', width: 1748, height: 2480, unit: 'px' },
    { name: 'A4', width: 2480, height: 3508, unit: 'px' },
    { name: 'Digital', width: 1080, height: 1350, unit: 'px' },
  ],
  supportedOrientations: ['portrait'],
  supportsMultiplePages: false,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Headline', 'Subheadline', 'Hero Image', 'Offer', 'CTA', 'Contact', 'Footer'],
};
